module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/04-ef31a4e6048286e924d3afe2bb0b922b.jpg";